import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { Modal } from '@mui/material';

import { ModalContent } from './styles';

interface CustomModalProps {
  maxWidth?: number;
  isLoading?: boolean;
  open: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  children: React.ReactNode;
}

const CustomModal: React.FC<CustomModalProps> = ({
  maxWidth,
  isLoading,
  open,
  onClose,
  title,
  description,
  children,
}: CustomModalProps) => {
  return (
    <Modal
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      open={open}
      onClose={onClose}
    >
      <ModalContent maxWidth={maxWidth}>
        <header>
          {!isLoading ? (
            <>
              <h2 id="modal-title" className="modal-title">
                {title}
              </h2>
              {description && (
                <p id="modal-description" className="modal-description">
                  {description}
                </p>
              )}
            </>
          ) : (
            <>
              <Skeleton height={28} width={200} />
              <Skeleton height={24} width={400} />
            </>
          )}
        </header>
        <div>{children}</div>
      </ModalContent>
    </Modal>
  );
};

export default CustomModal;
